<div mat-dialog-title class="name">
  Agendamientos por correo
</div>

<div mat-dialog-content class="content">

  <ng-container *ngFor="let booking of mails; let index = index; let first = first">
    <div class="bookings" [class.first]="first">
      <div class="info first">
        <div class="name">ID</div>
        <div class="value">{{booking.id}}</div>
      </div>
      <div class="info">
        <div class="name">Local</div>
        <div class="value">{{booking.data?.location?.name}}</div>
      </div>
      <div class="info">
        <div class="name">RUT</div>
        <div class="value">{{booking.data?.client?.rut || 'Sin rut'}}</div>
      </div>
      <div class="info">
        <div class="name">Nombre</div>
        <div class="value">{{booking.data?.client?.name || 'Sin cliente'}}</div>
      </div>
      <div class="info">
        <div class="name">Patente</div>
        <div class="value">{{booking.data?.vehicle?.plate || booking.data?.vehicle?.identifier || 'Sin patente'}}</div>
      </div>
      <div class="info">
        <div class="name">Requerimiento</div>
        <div class="value">{{booking.data?.requirement?.name}}</div>
      </div>
      <div class="info">
        <div class="name">Fecha</div>
        <div class="value">{{booking.data?.booking?.booking_date}}</div>
      </div>
      <div class="info">
        <div class="name">Hora</div>
        <div class="value">{{booking.data?.booking?.booking_time}}</div>
      </div>
    </div>
    <div class="buttons">
        <button mat-raised-button class="error display-desktop" (click)="removeMail(booking)">Descartar</button>
        <button mat-mini-fab class="error display-mobile" (click)="removeMail(booking)"><mat-icon>delete</mat-icon></button>
        <div class="expander"></div>
        <button mat-raised-button class="green" (click)="addBooking(booking)" *ngIf="!booking.is_booked">Agendar</button>
        <button mat-raised-button class="primary" *ngIf="booking.is_booked" (click)="openBooking(booking)"><i class="fa fa-check"></i> Ver Agendadamiento</button>
    </div>
  </ng-container>

</div>


<div mat-dialog-actions class="footer">
<button mat-button mat-dialog-close cdkFocusInitial>Cerrar</button>
</div>
